export const beltWidthRating = [400, 450, 500, 600, 750, 900, 1050, 1200, 1400, 1600, 1800, 2000, 2200];

export const beltWeightByJIS = [
    // Tentative Max. Tension 계산용으로만 사용
    {
        beltWidth: 400,
        weightByJIS: 9.0,
    },
    {
        beltWidth: 450,
        weightByJIS: 12.0,
    },
    {
        beltWidth: 500,
        weightByJIS: 12.0,
    },
    {
        beltWidth: 600,
        weightByJIS: 12.0,
    },
    {
        beltWidth: 750,
        weightByJIS: 13.0,
    },
    {
        beltWidth: 900,
        weightByJIS: 13.0,
    },
    {
        beltWidth: 1050,
        weightByJIS: 17.0,
    },
    {
        beltWidth: 1200,
        weightByJIS: 17.0,
    },
    {
        beltWidth: 1400,
        weightByJIS: 18.0,
    },
    {
        beltWidth: 1600,
        weightByJIS: 18.0,
    },
    {
        beltWidth: 1800,
        weightByJIS: 20.0,
    },
    {
        beltWidth: 2000,
        weightByJIS: 20.0,
    },
    {
        beltWidth: 2200,
        weightByJIS: 20.0,
    },
];

export const nylonBelt = [  // DRB
    {
        category: 1,
        label: 'NN160/2',
        strength: 160,
        plyNumber: 2,
        plyThickness: 1.8,
        plyWeight: 2.1,
        minPulleyDia: 200,
    },
    {
        category: 1,
        label: 'NN160/3',
        strength: 160,
        plyNumber: 3,
        plyThickness: 2.7,
        plyWeight: 3.15,
        minPulleyDia: 250,
    },
    {
        category: 2,
        label: 'NN250/2',
        strength: 250,
        plyNumber: 2,
        plyThickness: 2.2,
        plyWeight: 2.4,
        minPulleyDia: 200,
    },
    {
        category: 2,
        label: 'NN250/3',
        strength: 250,
        plyNumber: 3,
        plyThickness: 2.7,
        plyWeight: 3.15,
        minPulleyDia: 250,
    },
    {
        category: 3,
        label: 'NN315/2',
        strength: 315,
        plyNumber: 2,
        plyThickness: 2.0, // 250보다 작다. 검증 필요.
        plyWeight: 2.4,
        minPulleyDia: 200,
    },
    {
        category: 3,
        label: 'NN315/3',
        strength: 315,
        plyNumber: 3,
        plyThickness: 2.7,
        plyWeight: 3.15,
        minPulleyDia: 250,
    },
    {
        category: 3,
        label: 'NN315/4',
        strength: 315,
        plyNumber: 4,
        plyThickness: 3.6,
        plyWeight: 4.2,
        minPulleyDia: 350,
    },
    {
        category: 4,
        label: 'NN400/2',
        strength: 400,
        plyNumber: 2,
        plyThickness: 2.4,
        plyWeight: 2.9,
        minPulleyDia: 250,
    },
    {
        category: 4,
        label: 'NN400/3',
        strength: 400,
        plyNumber: 3,
        plyThickness: 3.0,
        plyWeight: 3.6,
        minPulleyDia: 300,
    },
    {
        category: 4,
        label: 'NN400/4',
        strength: 400,
        plyNumber: 4,
        plyThickness: 3.6,
        plyWeight: 4.2,
        minPulleyDia: 350,
    },
    {
        category: 5,
        label: 'NN500/2',
        strength: 500,
        plyNumber: 2,
        plyThickness: 2.6,
        plyWeight: 3.2,
        minPulleyDia: 250,
    },
    {
        category: 5,
        label: 'NN500/3',
        strength: 500,
        plyNumber: 3,
        plyThickness: 3.45,
        plyWeight: 4.3,
        minPulleyDia: 300,
    },
    {
        category: 5,
        label: 'NN500/4',
        strength: 500,
        plyNumber: 4,
        plyThickness: 3.8,
        plyWeight: 4.4,
        minPulleyDia: 350,
    },
    {
        category: 6,
        label: 'NN630/2',
        strength: 630,
        plyNumber: 2,
        plyThickness: 2.7,
        plyWeight: 3.4,
        minPulleyDia: 300,
    },
    {
        category: 6,
        label: 'NN630/3',
        strength: 630,
        plyNumber: 3,
        plyThickness: 3.6,
        plyWeight: 4.35,
        minPulleyDia: 350,
    },
    {
        category: 6,
        label: 'NN630/4',
        strength: 630,
        plyNumber: 4,
        plyThickness: 4.6,
        plyWeight: 5.75,
        minPulleyDia: 400,
    },
    {
        category: 6,
        label: 'NN630/5',
        strength: 630,
        plyNumber: 5,
        plyThickness: 4.75,
        plyWeight: 5.5, // 4P보다 무게나 가볍다.
        minPulleyDia: 450,
    },
    {
        category: 7,
        label: 'NN800/2',
        strength: 800,
        plyNumber: 2,
        plyThickness: 3.4,
        plyWeight: 3.9,
        minPulleyDia: 350,
    },
    {
        category: 7,
        label: 'NN800/3',
        strength: 800,
        plyNumber: 3,
        plyThickness: 3.9,
        plyWeight: 4.8,
        minPulleyDia: 400,
    },
    {
        category: 7,
        label: 'NN800/4',
        strength: 800,
        plyNumber: 4,
        plyThickness: 4.8,
        plyWeight: 5.8,
        minPulleyDia: 450,
    },
    {
        category: 7,
        label: 'NN800/5',
        strength: 800,
        plyNumber: 5,
        plyThickness: 5.75,
        plyWeight: 7.15,
        minPulleyDia: 500,
    },
    {
        category: 8,
        label: 'NN1000/2',
        strength: 1000,
        plyNumber: 2,
        plyThickness: 3.8,
        plyWeight: 4.3,
        minPulleyDia: 400,
    },
    {
        category: 8,
        label: 'NN1000/3',
        strength: 1000,
        plyNumber: 3,
        plyThickness: 4.8,
        plyWeight: 5.4,
        minPulleyDia: 450,
    },
    {
        category: 8,
        label: 'NN1000/4',
        strength: 1000,
        plyNumber: 4,
        plyThickness: 5.2,
        plyWeight: 6.4,
        minPulleyDia: 500,
    },
    {
        category: 8,
        label: 'NN1000/5',
        strength: 1000,
        plyNumber: 5,
        plyThickness: 6.0,
        plyWeight: 7.25,
        minPulleyDia: 500,
    },
    {
        category: 9,
        label: 'NN1250/3',
        strength: 1250,
        plyNumber: 3,
        plyThickness: 5.4,
        plyWeight: 6.3,
        minPulleyDia: 500,
    },
    {
        category: 9,
        label: 'NN150/4',
        strength: 1250,
        plyNumber: 4,
        plyThickness: 6.4,
        plyWeight: 7.2,
        minPulleyDia: 550,
    },
    {
        category: 9,
        label: 'NN1250/5',
        strength: 1250,
        plyNumber: 5,
        plyThickness: 6.5,
        plyWeight: 8.0,
        minPulleyDia: 650,
    },
    {
        category: 10,
        label: 'NN1500/3',
        strength: 1500,
        plyNumber: 3,
        plyThickness: 5.7,
        plyWeight: 6.45,
        minPulleyDia: 'unknown',
    },
    {
        category: 10,
        label: 'NN1500/4',
        strength: 1500,
        plyNumber: 4,
        plyThickness: 6.8,
        plyWeight: 7.8,
        minPulleyDia: 650,
    },
    {
        category: 10,
        label: 'NN1500/5',
        strength: 1500,
        plyNumber: 5,
        plyThickness: 6.75,
        plyWeight: 8.5,
        minPulleyDia: 700,
    },
    {
        category: 10,
        label: 'NN1500/6',
        strength: 1500,
        plyNumber: 6,
        plyThickness: 8.1,
        plyWeight: 10.2,
        minPulleyDia: 750,
    },
    {
        category: 11,
        label: 'NN180/4',
        strength: 1800,
        plyNumber: 4,
        plyThickness: 7.6,
        plyWeight: 8.6,
        minPulleyDia: 'unknown',
    },
    {
        category: 11,
        label: 'NN1800/5',
        strength: 1800,
        plyNumber: 5,
        plyThickness: 8.5,
        plyWeight: 9.75,
        minPulleyDia: 800,
    },
    {
        category: 11,
        label: 'NN1800/6',
        strength: 1800,
        plyNumber: 6,
        plyThickness: 9.6,
        plyWeight: 10.8,
        minPulleyDia: 900,
    },
];

export const polyesterBelt = [  // DRB
    {
        category: 1,
        label: 'EP160/2',
        strength: 160,
        plyNumber: 2,
        plyThickness: 1.8,
        plyWeight: 2.7,
        minPulleyDia: 200,
    },
    {
        category: 1,
        label: 'EP160/3',
        strength: 160,
        plyNumber: 3,
        plyThickness: 2.2,
        plyWeight: 3.3,
        minPulleyDia: 250,
    },
    {
        category: 2,
        label: 'EP250/2',
        strength: 250,
        plyNumber: 2,
        plyThickness: 2.0,
        plyWeight: 2.6,
        minPulleyDia: 300,
    },
    {
        category: 2,
        label: 'EP250/3',
        strength: 250,
        plyNumber: 3,
        plyThickness: 2.7,
        plyWeight: 3.3,
        minPulleyDia: 400,
    },
    {
        category: 3,
        label: 'EP315/2',
        strength: 315,
        plyNumber: 2,
        plyThickness: 2.3,
        plyWeight: 2.8,
        minPulleyDia: 300,
    },
    {
        category: 3,
        label: 'EP315/3',
        strength: 315,
        plyNumber: 3,
        plyThickness: 2.7,
        plyWeight: 3.3,
        minPulleyDia: 400,
    },
    {
        category: 3,
        label: 'EP315/4',
        strength: 315,
        plyNumber: 4,
        plyThickness: 3.6,
        plyWeight: 4.4,
        minPulleyDia: 400,
    },
    {
        category: 4,
        label: 'EP400/2',
        strength: 400,
        plyNumber: 2,
        plyThickness: 2.6,
        plyWeight: 3.4,
        minPulleyDia: 350,
    },
    {
        category: 4,
        label: 'EP400/3',
        strength: 400,
        plyNumber: 3,
        plyThickness: 3.45,
        plyWeight: 4.2,
        minPulleyDia: 400,
    },
    {
        category: 4,
        label: 'EP400/4',
        strength: 400,
        plyNumber: 4,
        plyThickness: 3.6,
        plyWeight: 4.4,
        minPulleyDia: 550,
    },
    {
        category: 5,
        label: 'EP500/2',
        strength: 500,
        plyNumber: 2,
        plyThickness: 2.8,
        plyWeight: 3.6,
        minPulleyDia: 350,
    },
    {
        category: 5,
        label: 'EP500/3',
        strength: 500,
        plyNumber: 3,
        plyThickness: 3.6,
        plyWeight: 4.35,
        minPulleyDia: 450,
    },
    {
        category: 5,
        label: 'EP500/4',
        strength: 500,
        plyNumber: 4,
        plyThickness: 4.0,
        plyWeight: 5.2,
        minPulleyDia: 550,
    },
    {
        category: 6,
        label: 'EP630/2',
        strength: 630,
        plyNumber: 2,
        plyThickness: 3.2,
        plyWeight: 4.0,
        minPulleyDia: 400,
    },
    {
        category: 6,
        label: 'EP630/3',
        strength: 630,
        plyNumber: 3,
        plyThickness: 3.9,
        plyWeight: 5.1,
        minPulleyDia: 500,
    },
    {
        category: 6,
        label: 'EP630/4',
        strength: 630,
        plyNumber: 4,
        plyThickness: 4.8,
        plyWeight: 5.8,
        minPulleyDia: 550,
    },
    {
        category: 6,
        label: 'EP630/5',
        strength: 630,
        plyNumber: 5,
        plyThickness: 5.75,
        plyWeight: 7.0,
        minPulleyDia: 550,
    },
    {
        category: 7,
        label: 'EP800/2',
        strength: 800,
        plyNumber: 2,
        plyThickness: 3.7,
        plyWeight: 4.8,
        minPulleyDia: 450,
    },
    {
        category: 7,
        label: 'EP800/3',
        strength: 800,
        plyNumber: 3,
        plyThickness: 4.8,
        plyWeight: 6.0,
        minPulleyDia: 550,
    },
    {
        category: 7,
        label: 'EP800/4',
        strength: 800,
        plyNumber: 4,
        plyThickness: 5.2,
        plyWeight: 6.8,
        minPulleyDia: 650,
    },
    {
        category: 7,
        label: 'EP800/5',
        strength: 800,
        plyNumber: 5,
        plyThickness: 6.5,
        plyWeight: 8.5,
        minPulleyDia: 700,
    },
    {
        category: 8,
        label: 'EP1000/2',
        strength: 1000,
        plyNumber: 2,
        plyThickness: 5.0,
        plyWeight: 5.2,
        minPulleyDia: 500,
    },
    {
        category: 8,
        label: 'EP1000/3',
        strength: 1000,
        plyNumber: 3,
        plyThickness: 5.1,
        plyWeight: 6.6,
        minPulleyDia: 600,
    },
    {
        category: 8,
        label: 'EP1000/4',
        strength: 1000,
        plyNumber: 4,
        plyThickness: 5.6,
        plyWeight: 7.2,
        minPulleyDia: 700,
    },
    {
        category: 8,
        label: 'EP1000/5',
        strength: 1000,
        plyNumber: 5,
        plyThickness: 7.0,
        plyWeight: 9.0,
        minPulleyDia: 800,
    },
    {
        category: 9,
        label: 'EP1250/3',
        strength: 1250,
        plyNumber: 3,
        plyThickness: 5.5,
        plyWeight: 7.2,
        minPulleyDia: 700,
    },
    {
        category: 9,
        label: 'EP1250/4',
        strength: 1250,
        plyNumber: 4,
        plyThickness: 6.4,
        plyWeight: 8.0,
        minPulleyDia: 750,
    },
    {
        category: 9,
        label: 'EP1250/5',
        strength: 1250,
        plyNumber: 5,
        plyThickness: 8.0,
        plyWeight: 10.0,
        minPulleyDia: 850,
    },
    {
        category: 10,
        label: 'EP1500/3',
        strength: 1500,
        plyNumber: 3,
        plyThickness: 6.0,
        plyWeight: 7.8,
        minPulleyDia: 'unknown',
    },
    {
        category: 10,
        label: 'EP1500/4',
        strength: 1500,
        plyNumber: 4,
        plyThickness: 7.4,
        plyWeight: 9.6,
        minPulleyDia: 850,
    },
    {
        category: 10,
        label: 'EP1500/5',
        strength: 1500,
        plyNumber: 5,
        plyThickness: 8.0,
        plyWeight: 10.0,
        minPulleyDia: 950,
    },
    {
        category: 10,
        label: 'EP1500/6',
        strength: 1500,
        plyNumber: 6,
        plyThickness: 9.6,
        plyWeight: 12.0,
        minPulleyDia: 1050,
    },
    {
        category: 11,
        label: 'EP1800/4',
        strength: 1800,
        plyNumber: 4,
        plyThickness: 8.0,
        plyWeight: 10.4,
        minPulleyDia: 'unknown',
    },
    {
        category: 11,
        label: 'EP1800/5',
        strength: 1800,
        plyNumber: 5,
        plyThickness: 9.25,
        plyWeight: 12.0,
        minPulleyDia: 1050,
    },
    {
        category: 11,
        label: 'EP1800/6',
        strength: 1800,
        plyNumber: 6,
        plyThickness: 9.9,
        plyWeight: 12.6,
        minPulleyDia: 1100,
    },
];

export const steelCordBelt = [  // STAHLCORD_Contitech
    {
        label: 'ST500',
        strength: 500,
        cordDia: 2.8, // mm
        cordPitch: 14, // mm
        coreWeight: 5.7, // kg/m2
        minPulleyDia: 500, // mm
        beltSpliceLength: 600, // mm
        numberOfStep: 1,
    },
    {
        label: 'ST630',
        strength: 630,
        cordDia: 2.8,
        cordPitch: 12,
        coreWeight: 6.1,
        minPulleyDia: 500,
        beltSpliceLength: 600,
        numberOfStep: 1,
    },
    {
        label: 'ST800',
        strength: 800,
        cordDia: 2.8,
        cordPitch: 10,
        coreWeight: 6.5,
        minPulleyDia: 500,
        beltSpliceLength: 600,
        numberOfStep: 1,
    },
    {
        label: 'ST1000',
        strength: 1000,
        cordDia: 3.6,
        cordPitch: 12,
        coreWeight: 8.6,
        minPulleyDia: 630,
        beltSpliceLength: 600,
        numberOfStep: 1,
    },
    {
        label: 'ST1120',
        strength: 1120,
        cordDia: 3.6,
        cordPitch: 11,
        coreWeight: 10.1,
        minPulleyDia: 630,
        beltSpliceLength: 650,
        numberOfStep: 1,
    },
    {
        label: 'ST1250',
        strength: 1250,
        cordDia: 4.4,
        cordPitch: 14,
        coreWeight: 10.6,
        minPulleyDia: 800,
        beltSpliceLength: 650,
        numberOfStep: 1,
    },
    {
        label: 'ST1400',
        strength: 1400,
        cordDia: 4.4,
        cordPitch: 12,
        coreWeight: 11.3,
        minPulleyDia: 800,
        beltSpliceLength: 950,
        numberOfStep: 2,
    },
    {
        label: 'ST1600',
        strength: 1600,
        cordDia: 5.1,
        cordPitch: 15,
        coreWeight: 12.4,
        minPulleyDia: 800,
        beltSpliceLength: 750,
        numberOfStep: 1,
    },
    {
        label: 'ST1800',
        strength: 1800,
        cordDia: 5.1,
        cordPitch: 14,
        coreWeight: 12.8,
        minPulleyDia: 800,
        beltSpliceLength: 800,
        numberOfStep: 1,
    },
    {
        label: 'ST2000',
        strength: 2000,
        cordDia: 5.1,
        cordPitch: 12,
        coreWeight: 14.0,
        minPulleyDia: 800,
        beltSpliceLength: 1150,
        numberOfStep: 2,
    },
    {
        label: 'ST2250',
        strength: 2250,
        cordDia: 5.3,
        cordPitch: 12,
        coreWeight: 14.6,
        minPulleyDia: 800,
        beltSpliceLength: 1250,
        numberOfStep: 2,
    },
    {
        label: 'ST2500',
        strength: 2500,
        cordDia: 6.7,
        cordPitch: 15,
        coreWeight: 18.0,
        minPulleyDia: 1000,
        beltSpliceLength: 1350,
        numberOfStep: 2,
    },
    {
        label: 'ST2800',
        strength: 2800,
        cordDia: 6.7,
        cordPitch: 14,
        coreWeight: 18.6,
        minPulleyDia: 1000,
        beltSpliceLength: 1450,
        numberOfStep: 2,
    },
    {
        label: 'ST3150',
        strength: 3150,
        cordDia: 7.5,
        cordPitch: 15,
        coreWeight: 21.7,
        minPulleyDia: 1250,
        beltSpliceLength: 1650,
        numberOfStep: 2,
    },
    {
        label: 'ST3500',
        strength: 3500,
        cordDia: 8.1,
        cordPitch: 15,
        coreWeight: 24.1,
        minPulleyDia: 1250,
        beltSpliceLength: 2350,
        numberOfStep: 3,
    },
    {
        label: 'ST4000',
        strength: 4000,
        cordDia: 8.6,
        cordPitch: 15,
        coreWeight: 25.8,
        minPulleyDia: 1250,
        beltSpliceLength: 2650,
        numberOfStep: 3,
    },
    {
        label: 'ST4500',
        strength: 4500,
        cordDia: 9.2,
        cordPitch: 16,
        coreWeight: 27.9,
        minPulleyDia: 1400,
        beltSpliceLength: 2800,
        numberOfStep: 3,
    },
    {
        label: 'ST5000',
        strength: 5000,
        cordDia: 10.4,
        cordPitch: 17,
        coreWeight: 31.4,
        minPulleyDia: 1600,
        beltSpliceLength: 4050,
        numberOfStep: 4,
    },
];

// export const steelCordBelt = [   // 데이터가 빈약한 것 같아 Contitech 자료(위)로 대체함.
//     {
//         strength: 500,
//         cordDia: 2.4,                           // mm
//         cordUnitWeight: 21.6,                   // g/m
//         cordWeight: 2.2,                        // kg/m2
//         cordPitch: 10,                          // mm
//         maxAllowableWorkingTension: 72,         // kN/m

//         minPulleyDia: [600, 500, 350],
//     },
//     {
//         strength: 630,
//         cordDia: 2.7,
//         cordUnitWeight: 28.1,
//         cordWeight: 2.8,
//         cordPitch: 10,
//         maxAllowableWorkingTension: 90,
//         minPulleyDia: [600, 500, 350],
//     },
//     {
//         strength: 800,
//         cordDia: 3.1,
//         cordUnitWeight: 36.9,
//         cordWeight: 3.7,
//         cordPitch: 10,
//         maxAllowableWorkingTension: 115,
//         minPulleyDia: [650, 500, 400],
//     },
//     {
//         strength: 900,
//         cordDia: 3.3,
//         cordUnitWeight: 42.8,
//         cordWeight: 4.3,
//         cordPitch: 10,
//         maxAllowableWorkingTension: 130,
//         minPulleyDia: [700, 550, 450],
//     },
//     {
//         strength: 1000,
//         cordDia: 3.6,
//         cordUnitWeight: 51.1,
//         cordWeight: 4.3,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 145,
//         minPulleyDia: [750, 600, 500],
//     },
//     {
//         strength: 1250,
//         cordDia: 4.0,
//         cordUnitWeight: 63.9,
//         cordWeight: 5.3,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 180,
//         minPulleyDia: [850, 700, 500],
//     },
//     {
//         strength: 1400,
//         cordDia: 4.3,
//         cordUnitWeight: 73.5,
//         cordWeight: 6.1,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 200,
//         minPulleyDia: [950, 750, 510],
//     },
//     {
//         strength: 1600,
//         cordDia: 4.7,
//         cordUnitWeight: 86.7,
//         cordWeight: 7.2,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 230,
//         minPulleyDia: [1000, 800, 600],
//     },
//     {
//         strength: 1800,
//         cordDia: 5.0,
//         cordUnitWeight: 97.2,
//         cordWeight: 8.1,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 260,
//         minPulleyDia: [1200, 950, 700],
//     },
//     {
//         strength: 2000,
//         cordDia: 5.2,
//         cordUnitWeight: 105.0,
//         cordWeight: 8.8,
//         cordPitch: 12,
//         maxAllowableWorkingTension: 290,
//         minPulleyDia: [1200, 950, 700],
//     },
//     {
//         strength: 2500,
//         cordDia: 6.8,
//         cordUnitWeight: 182.0,
//         cordWeight: 12.1,
//         cordPitch: 15,
//         maxAllowableWorkingTension: 360,
//         minPulleyDia: [1500, 1200, 900],
//     },
//     {
//         strength: 2800,
//         cordDia: 7.2,
//         cordUnitWeight: 206.0,
//         cordWeight: 13.7,
//         cordPitch: 15,
//         maxAllowableWorkingTension: 400,
//         minPulleyDia: [1550, 1250, 950],
//     },
//     {
//         strength: 3150,
//         cordDia: 7.6,
//         cordUnitWeight: 224.0,
//         cordWeight: 14.9,
//         cordPitch: 15,
//         maxAllowableWorkingTension: 450,
//         minPulleyDia: [1700, 1350, 1000],
//     },
//     {
//         strength: 4000,
//         cordDia: 8.6,
//         cordUnitWeight: 291.0,
//         cordWeight: 19.4,
//         cordPitch: 15,
//         maxAllowableWorkingTension: 580,
//         minPulleyDia: [1850, 1400, 1050],
//     },
//     {
//         strength: 5000,
//         cordDia: 9.6,
//         cordUnitWeight: 360.0,
//         cordWeight: 24.0,
//         cordPitch: 15,
//         maxAllowableWorkingTension: 720,
//         minPulleyDia: [2100, 1700, 1250],
//     },
// ];
